import React from 'react';
import './StrangerChat2.css';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

export default function StrangerChat2() {

  // Handler functions
  const handleFindSomeoneNew = () => {
    alert('Finding a new chat partner...');
  };

  const handleSearch = () => {
    alert('Opening search...');
  };

  const handleNotifications = () => {
    alert('Opening notifications...');
  };

  const handleInfo = () => {
    alert('Showing chat information...');
  };

  const handleAttachment = () => {
    alert('Opening attachment picker...');
  };

  const handleVoiceMessage = () => {
    alert('Recording voice message...');
  };

  const handleEmoji = () => {
    alert('Opening emoji picker...');
  };

  const handleSendMessage = () => {
    alert('Sending message...');
  };

  return (
    <div className="stranger-chat2-page page-with-header">
      <Header />
      
      {/* Orange Header Bar */}
      <div className="orange-header">
        <div className="orange-header-content">
          <div className="user-info">
            <div className="user-avatar">AT</div>
            <span className="user-name">Alex Thompson</span>
          </div>
          <div className="header-actions">
            <button className="find-someone-btn" onClick={handleFindSomeoneNew}>TÌM NGƯỜI MỚI</button>
            <button className="header-icon" onClick={handleSearch}>🔍</button>
            <button className="header-icon" onClick={handleNotifications}>🔔</button>
            <button className="header-icon" onClick={handleInfo}>ℹ️</button>
          </div>
        </div>
      </div>

      {/* Main Chat Section */}
      <section className="stranger-chat-section">
        <div className="chat-content">
          {/* Chat Messages */}
          <div className="chat-messages">
            <div className="message stranger-message">
              <div className="message-bubble stranger-bubble">
                <p>Tôi đã phải vật lộn với lo âu gần đây. Cảm giác như mọi thứ đều quá sức.</p>
                <span className="timestamp">03:15 PM</span>
              </div>
            </div>
            
            <div className="message user-message">
              <div className="message-bubble user-bubble">
                <p>Tôi hiểu cảm giác đó. Bạn không cô đơn trong việc này. Điều gì giúp bạn cảm thấy vững vàng hơn?</p>
                <span className="timestamp">03:16 PM</span>
              </div>
            </div>
            
            <div className="message stranger-message">
              <div className="message-bubble stranger-bubble">
                <p>Đôi khi chỉ cần nói về nó đã giúp ích. Cảm ơn bạn đã lắng nghe mà không phán xét.</p>
                <span className="timestamp">03:17 PM</span>
              </div>
            </div>
            
            <div className="message user-message">
              <div className="message-bubble user-bubble">
                <p>Đó là lý do chúng ta ở đây. Đôi khi hành động đơn giản là chia sẻ có thể tạo ra sự khác biệt lớn.</p>
                <span className="timestamp">03:18 PM</span>
              </div>
            </div>
            
            <div className="message stranger-message">
              <div className="message-bubble stranger-bubble">
                <p>It really does. I feel a bit lighter already. Thank you for being so kind.</p>
                <span className="timestamp">03:19 PM</span>
              </div>
            </div>
          </div>

          {/* Chat Input */}
          <div className="chat-input">
            <div className="input-icons">
              <button className="input-icon" onClick={handleAttachment}>📎</button>
            </div>
            <div className="input-field">
              <input 
                type="text" 
                placeholder="Message Random..." 
                className="message-input"
              />
            </div>
            <div className="input-actions">
              <button className="input-icon" onClick={handleVoiceMessage}>🎤</button>
              <button className="input-icon" onClick={handleEmoji}>😊</button>
              <button className="send-btn" onClick={handleSendMessage}>
                Send
                <span className="send-icon">✈️</span>
              </button>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

